module.exports = __webpack_public_path__ + "static/TiemposHeadlineWeb-Semibold-de8f26860d15d1d13bf2d4afcd70ff18.eot";